import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import ServiceProviderCard from "./ServiceProviderCard";
import {
  getServiceProviderList,
  deleteServiceProviderDetails,
  getPortAndCountry,
} from "../Actions/ServiceProviderAPI";
import { toast } from "react-toastify";
import axios from "axios";
import API from "../helpers/api";
import Autocomplete from "react-autocomplete";
import { confirmAlert } from "react-confirm-alert";
import $ from "jquery";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));
let SearchItems = {
  ServiceProviderName: "",
  port: "",
  country: "",
  PageNumber: 1,
  PageSize: 20,
}
class ServicedBy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        ServiceProviderName: "",
        port: "",
        country: "",
        PageNumber: 1,
        PageSize: 20,
      },
      serviceProviderName: "",
      port: "",
      country: "",
    };
    this.SearchServiceProvider = this.SearchServiceProvider.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleInputChanges = this.handleInputChanges.bind(this);
    this.renderPortTitle = this.renderPortTitle.bind(this);
    this.renderCountryTitle = this.renderCountryTitle.bind(this);
  }

  componentDidMount() {
    const { dispatch ,t} = this.props;
    this.props.dispatch(getPortAndCountry(this.state));
    if (this.props.serviceBySearch) {
      this.state.searchData = this.props.serviceBySearch;
    }
    dispatch(getServiceProviderList(this.state.searchData));
    dispatch({ type: "SubBannerTitle", data: "Serviced By" });
    let searchitem = this.state.searchData;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;
      // if (
      //   // searchitem.ServiceProviderName ||
      //   // searchitem.port ||
      //   // searchitem.country
      //   _this.verifySearchItems()
      // ) {
      if (keycode === 13) {
        if (_this.verifySearchItems()) {
          _this.SearchServiceProvider(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  SearchServiceProvider(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    dispatch({ type: "serviceBySearch", data: this.state.searchData });
    dispatch(getServiceProviderList(this.state.searchData));
    this.setState({});
  }

  verifySearchItems = () => {
    let flag = true;
    const search = this.state.searchData;
    if (search.ServiceProviderName == "" && search.port == "" && search.country == "") {
      flag = false;
    }
    return flag;
  }

  SearchServiceProvider1(pgno) {
    if (this.verifySearchItems()) {
      const { dispatch } = this.props;
      this.state.searchData.PageNumber = pgno;
      dispatch({ type: "serviceBySearch", data: this.state.searchData });
      dispatch(getServiceProviderList(this.state.searchData));
      this.setState({});
    }
    else {
      toast.success("Please select atleast one value", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
    // this.state.searchData.ServiceProviderName = e.target.value;
    // this.setState({});
  }

  ClearInput() {
    this.state.searchData.ServiceProviderName = "";
    this.state.searchData.port = "";
    this.state.searchData.country = "";
    this.setState({});
    this.props.dispatch({ type: "serviceBySearch", data: "" });
    this.props.dispatch(getServiceProviderList(this.state.searchData));
  }

  deleteServiceProvider(item) {
    const { t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { dispatch, ServiceProviderList } = this.props;
            let service = {
              serviceProviderId: item.serviceProviderId,
              serviceProviderName: item.serviceProviderName,
              email: item.email,
              phone1: item.phone1,
              phone2: item.phone2,
              isDeleted: true,
              modifiedBy: currentuser.name,
            };
            // dispatch(deleteServiceProviderDetails(service));
            let url = `${API.postServiceProvider}`;
            axios
              .put(url, service)
              .then((response) => {
                let searchData = {
                  ServiceProviderName: "",
                  PageNumber: this.state.searchData.PageNumber - 1,
                  PageSize: 20,
                };
                if (
                  ServiceProviderList.pagination.hasNext === false &&
                  ServiceProviderList.data.length === 1
                ) {
                  dispatch({ type: "serviceBySearch", data: searchData });
                  dispatch(getServiceProviderList(searchData));
                } else {
                  dispatch({ type: "serviceBySearch", data: this.state.searchData });
                  dispatch(getServiceProviderList(this.state.searchData));
                }
                dispatch({
                  type: "deleteServiceProviderDetailSuccess",
                  data: response.data,
                });
                toast.success(`${t("CommonText.CommonDelete")}`, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                this.ClearInput()
              })
              .catch((error) => {
                dispatch({
                  type: "deleteServiceProviderDetailFailure",
                  error: "ERROR",
                });
              });
          }
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => { }
        }
      ]
    });
  }

  eyeclick(item) {
    this.setState({ showSidePane: true });
    // this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.dispatch({
      type: "getServiceProviderDetailSuccess",
      data: item,
    });
    this.props.history.push(
      `/Home/EditServiceProvider/${item.serviceProviderId}`
    );
  }

  NewitemNav = () => {
    // this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push("/Home/AddServiceProvider");
  };

  handleInputChanges(e, field) {
    this.state.searchData[field] = e.target.value;
    if (e.target.value === "" && field === "port") {
      this.state.searchData.country = "";
      this.setState({});
      this.props.dispatch(getPortAndCountry(this.state.searchData));
    } else {
      this.props.dispatch(getPortAndCountry(this.state.searchData));
    }

    this.setState({});
  }

  handleSelectChange(value, field) {
    this.state.searchData[field] = value;
    this.props.dispatch(getPortAndCountry(this.state.searchData));
    this.setState({});
  }
  renderCountryTitle(state, val) {
    return state?.country?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }
  renderPortTitle(state, val) {
    return state?.port?.toLowerCase().indexOf(val?.toLowerCase()) !== -1;
  }

  render() {
    const {
      ServiceProviderList,
      PortList,
      CountryList,
      t
    } = this.props;

    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className="card MM-card-header"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2 f2"
                          style={{ color: "092a51" }}
                        >
                          {t("ServicedByScreenContent.Title")}
                        </h5>
                        <div className="m-1 flex" onClick={this.NewitemNav}>
                          <span className="mt-1">{t("ShipManagementContent.Add")}</span>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div className="col-lg-4">
                          <label className="form-label">{t("ShipDetailsScreen.ServiceProvider")}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="ServiceProviderName"
                            placeholder={t("ShipDetailsScreen.ServiceProvider")}
                            value={this.state.searchData.ServiceProviderName}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        {/* <div className="col-lg-4">
                          <div className="autocomplete-wrappers">
                            <label className="form-label">
                              Service Provider
                            </label>
                            <br></br>
                            <Autocomplete
                              contentEditable={true}
                              value={this.state.serviceProviderName}
                              inputProps={{ placeholder: "Service Provider" }}
                              items={ServiceProviderPortList}
                              getItemValue={(item) => item.port}
                              shouldItemRender={this.renderPortTitle.bind(this)}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${
                                    isHighlighted ? "selected-items" : ""
                                  }`}
                                >
                                  {item.port}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChanges(
                                  e,
                                  "serviceProviderName"
                                )
                              }
                              onSelect={(value) =>
                                this.handleSelectChange(
                                  value,
                                  "serviceProviderName"
                                )
                              }
                            />
                          </div>
                        </div> */}
                        {/* <div className="col-lg-4">
                          <label className="form-label">Port</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="port"
                            placeholder="Port"
                            value={this.state.searchData.port}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div> */}
                        <div className="col-lg-4">
                          <div className="autocomplete-wrappers">
                            <label className="form-label">{t("TopPaneContent.Port")}</label>
                            <br></br>
                            <Autocomplete
                              contentEditable={true}
                              value={this.state.searchData.port}
                              inputProps={{ placeholder: `${t("TopPaneContent.Port")}` }}
                              items={PortList ?? []}
                              getItemValue={(item) => item.port}
                              shouldItemRender={this.renderPortTitle.bind(this)}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${isHighlighted ? "selected-items" : ""
                                    }`}
                                >
                                  {item.port}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChanges(e, "port")
                              }
                              onSelect={(value) =>
                                this.handleSelectChange(value, "port")
                              }
                            />
                          </div>
                        </div>
                        {/* <div className="col-lg-4">
                          <label className="form-label">Country</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="country"
                            placeholder="Country"
                            value={this.state.searchData.country}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div> */}
                        <div className="col-lg-4">
                          {/* <label className="form-label">Country</label><br></br>
                                    <select className="form-control" name="country" value={this.state.country} onChange={e => this.handlePortInputChange(e)}>
                                        <option value="">Select Country</option>
                                        {PortAndCountry && PortAndCountry.map(portName => (
                                            <option value={portName.country}>{portName.country}</option>
                                        ))}
                                    </select> */}
                          <div className="autocomplete-wrappers">
                            <label className="form-label">{t("EquipmentServiceTypes.Country")}</label>
                            <br></br>
                            <Autocomplete
                              contentEditable={true}
                              value={this.state.searchData.country}
                              inputProps={{ placeholder: `${t("EquipmentServiceTypes.Country")}` }}
                              items={CountryList ?? []}
                              getItemValue={(item) => item.country}
                              shouldItemRender={this.renderCountryTitle.bind(
                                this
                              )}
                              renderMenu={(item) => (
                                <div className="dropdown">{item}</div>
                              )}
                              renderItem={(item, isHighlighted) => (
                                <div
                                  className={`items ${isHighlighted ? "selected-items" : ""
                                    }`}
                                >
                                  {item.country}
                                </div>
                              )}
                              onChange={(e, field) =>
                                this.handleInputChanges(e, "country")
                              }
                              onSelect={(value) =>
                                this.handleSelectChange(value, "country")
                              }
                            />
                          </div>
                        </div>
                        <div
                          className="col-lg-12"
                          style={{
                            marginTop: "2.3rem",
                            marginBottom: "1.1rem",
                          }}
                        >
                          <div
                            className="search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchServiceProvider1(1)}
                            >
                              {" "}
                              {t("content.Search")}{" "}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              {t("content.Clear")}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {ServiceProviderList ? (
                <ServiceProviderCard
                  currentPage={(ServiceProviderList.pagination?.currentPage - 1) * ServiceProviderList.pagination?.pageSize}
                  arraylist={ServiceProviderList.data}
                  pageSize={ServiceProviderList.pagination?.pageSize ?? 0}
                  totalRecords={
                    ServiceProviderList.pagination?.totalcount
                      ? ServiceProviderList.pagination?.totalcount
                      : 0
                  }
                  setUpdatedState={(value) => this.SearchServiceProvider(value)}
                  eyeclick={(item) => this.eyeclick(item)}
                  deleteServiceProvider={(item) =>
                    this.deleteServiceProvider(item)
                  }
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    ServiceProviderList: state.MasterScreenReducer.ServiceProviderList || {},
    serviceBySearch: state.MasterScreenReducer.serviceBySearch,
    PortList: state.MasterScreenReducer.PortLists || [],
    CountryList: state.MasterScreenReducer.CountryList || [],
    ServiceProviderPortList:
      state.MasterScreenReducer.ServiceProviderPortList || [],
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ServicedBy)));
